import $ from 'jquery';

$( document ).ready(() => {
	const $loginModal = $( '#login-config-modal' );

	if ( $loginModal.data('reveal-modal') ) {
		$loginModal.foundation( 'open' );
	}

	loginPasswordValidation();
});

const $config_login_form = $( '#login_config_form' );
const $config_submit_button = $config_login_form.find( 'button' );
const $config_error_wrapper = $( '#login_config_modal__error' );
const $config_success_wrapper = $( '#login_config_modal__success' );
const $config_description_wrapper = $( '.login-modal__description' );
const $config_title = $( '.login-modal__title' );

$config_submit_button.on( 'click', function ( e ) {
	e.preventDefault();

	$.ajax( {
		type: "POST",
		url: psh_vars.rest_route.psh_old_login_create,
		data: $config_login_form.serializeArray(),
		beforeSend: function () {
			$config_error_wrapper.slideUp();
			$config_submit_button.addClass( 'loading' );
		},
		complete: function () {
			$config_submit_button.removeClass( 'loading' );
		},
		success: function ( data ) {
			if ( data.success ) {
				$config_success_wrapper.html( data.message );
				$config_title.html( data.title );
				$config_success_wrapper.slideDown();
				$config_login_form.hide();
				$config_description_wrapper.hide();
				setSkipOldLogin()
			} else {
				$config_error_wrapper.html( data.message );
				$config_error_wrapper.slideDown();
			}
		},
		error: function ( data ) {
			let error_message = JSON.parse( data.responseText );
			$config_error_wrapper.html( error_message.message );
			$config_error_wrapper.slideDown();
		}
	} );
} );

const $skip_button = $('.login-modal__wrapper-form-actions--skip');
$skip_button.on( 'click', function ( e ) {
	setSkipOldLogin();
} );

const setSkipOldLogin = () => {
	let name = 'skip_old_login';
	let exp = new Date();
	exp.setMonth(exp.getMonth() + 6);

	document.cookie = name + '=true;expires=' + exp.toUTCString() + ';path=/';
}

const getCookie = (cname) => {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return false;
}

const $PasswordField = $( '#login_config_password' );
const $PasswordFieldRepeat = $( '#login_config_password_repeat' );

const loginPasswordValidation = () => {
	$PasswordField.on( 'keyup', ( e, $PasswordField, $PasswordFieldRepeat ) => {
		passwordValidation( e, $PasswordField, $PasswordFieldRepeat )
	} );

	$PasswordFieldRepeat.on( 'keyup', ( e, $PasswordField, $PasswordFieldRepeat ) => {
		passwordValidation( e, $PasswordField, $PasswordFieldRepeat )
	} );
}

const passwordValidation = ( e ) => {
	// Check if string is minimum 8 characters long
	let value = $( e.currentTarget ).val();
	const passwordCharacters = $( '.password-requirements > .characters' );
	toggleClass( passwordCharacters, ( value.length >= 8 ) );

	const passwordSpecialCharacters = $( '.password-requirements > .special-characters' );
	const passwordLowerCaseCharacters = $( '.password-requirements > .lower-case' );
	const passwordUpperCaseCharacters = $( '.password-requirements > .upper-case' );
	const passwordNumberCharacters = $( '.password-requirements > .number' );

	if ( value.length === 0 ) {
		toggleClass( passwordCharacters, false, true );
		toggleClass( passwordNumberCharacters, false, true )
		toggleClass( passwordSpecialCharacters, false, true )
		toggleClass( passwordLowerCaseCharacters, false, true )
		toggleClass( passwordUpperCaseCharacters, false, true )

		return false;
	}

	let hasSpecialCharacter = false;
	let hasLowerCaseCharacter = false;
	let hasUpperCaseCharacter = false;
	let hasNumberCharacter = false;
	Object.entries( value ).forEach( character => {
		let char = character[ 1 ];

		let specialChars = [ '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', ',', '.', '?', '>', '<', '+', '_', '=', '~', ';', ':', '{', '}', '|', '[', ']', '-', '/', '(' ];
		let isNumber = false;
		let isSpecialChar = false;

		// Check if string has special character
		if ( specialChars.includes( char ) ) {
			isSpecialChar = true;
			hasSpecialCharacter = true;
		}

		// Check if string has a number
		if ( !isNaN( parseInt(char) ) ) {
			isNumber = true;
			hasNumberCharacter = true
		}

		// Check if string has lower case character
		if ( char === char.toLowerCase() && ! isNumber && ! isSpecialChar ) {
			hasLowerCaseCharacter = true;
		}

		// Check if string has upper case character
		if ( char === char.toUpperCase() && ! isNumber && ! isSpecialChar && char !== char.toLowerCase() ) {
			hasUpperCaseCharacter = true;
		}
	} );

	toggleClass( passwordSpecialCharacters, hasSpecialCharacter );
	toggleClass( passwordLowerCaseCharacters, hasLowerCaseCharacter );
	toggleClass( passwordUpperCaseCharacters, hasUpperCaseCharacter );
	toggleClass( passwordNumberCharacters, hasNumberCharacter );

	const hasFalseRequirements = $( '.password-requirements--false' );
	const nextButton = $( '.login-modal__wrapper-form-actions--next' );

	if ( hasFalseRequirements.length === 0 && $PasswordField.val() === $PasswordFieldRepeat.val() ) {
		nextButton.prop( 'disabled', false );
	} else {
		nextButton.prop( 'disabled', true );
	}
}

const toggleClass = ( element, success, isRemove = false ) => {
	const errorClass = 'password-requirements--false';
	const successClass = 'password-requirements--true';

	if ( isRemove ) {
		element.removeClass( errorClass );
		element.removeClass( successClass );

		return false;
	}

	if ( success ) {
		element.removeClass( errorClass );
		element.addClass( successClass );
	} else {
		element.addClass( errorClass );
		element.removeClass( successClass );
	}
}
